import styled from 'styled-components';
import { fonts } from 'styles';

export const Container = styled.footer`
  width: 100%;
  margin: 0 auto;
  padding-bottom: 124px;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 124px;

  @media screen and (max-width: 1024px) {
    padding-top: 96px;
    padding-bottom: 88px;
  }
`;

export const Header = styled.header`
  width: 100%;
  padding-bottom: 16px;
  border-bottom: 1px solid #000;
  font-family: ${fonts.BentonSansWideBold};
  font-size: 14px;
  line-height: 22px;
  color: #000;
  text-transform: uppercase;
  margin-bottom: 40px;
`;

export const Wrapper = styled.div`
  display: flex;
  column-gap: 128px;
  width: 100%;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    row-gap: 32px;
  }
`;

export const Column = styled.div`
  width: 100%;
  max-width: 530px;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  color: #000;

  h6 {
    font-family: ${fonts.BentonSansWideBold};
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 24px;
  }

  article {
    font-family: ${fonts.BentonSansRegular};
    font-size: 14px;
    line-height: 22px;
    display: block;
  }
`;
